import React, { useEffect, useState } from "react";
import { adminAircraft, adminUpdateAircraft } from "../../lib/api";
import { Picture, Price } from "../../lib/icons";

export default function AdminAircraft() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => adminAircraft().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async (code, body) => { await adminUpdateAircraft(code, body); setEdit(null); load(); };
  return (
    <div>
      <h1 className="adm-h1">Aircraft</h1>
      <p className="adm-sub">{rows.length} aircraft types. Toggle visibility on the public site and edit descriptions.</p>
      <div className="panel" style={{ padding: 6 }}>
        <table className="tbl">
          <thead><tr><th></th><th>Name</th><th>Class</th><th>Seats</th><th>Fleet</th><th>Cost</th><th>Visible</th></tr></thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.code} onClick={() => setEdit(edit === a.code ? null : a.code)}>
                <td style={{ width: 64 }}><div style={{ width: 52, height: 40, borderRadius: 8, overflow: "hidden", position: "relative" }}><Picture code={a.code} /></div></td>
                <td style={{ fontWeight: 700 }}>{a.name}
                  {edit === a.code ? (
                    <div onClick={(e) => e.stopPropagation()} style={{ fontWeight: 400, marginTop: 10, display: "grid", gap: 8, maxWidth: 520 }}>
                      <textarea defaultValue={a.description} id={`d-${a.code}`} style={{ border: "1px solid var(--line2)", borderRadius: 10, padding: 10, minHeight: 70 }} />
                      <div style={{ display: "flex", gap: 8 }}>
                        <button className="adm-btn primary" type="button" onClick={() => save(a.code, { description: document.getElementById(`d-${a.code}`).value })}>Save</button>
                        <button className="adm-btn" type="button" onClick={() => setEdit(null)}>Cancel</button>
                      </div>
                    </div>
                  ) : null}
                </td>
                <td>{a.cls_name}</td>
                <td>{a.seats_max || "\u2014"}</td>
                <td>{a.fleet_count}</td>
                <td><Price tier={a.tier} /></td>
                <td onClick={(e) => { e.stopPropagation(); save(a.code, { active: !a.active }); }}>
                  <span className={"pill " + (a.active ? "Confirmed" : "Lost")}>{a.active ? "Shown" : "Hidden"}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
